import '../style/health-bar-B2M2VEBx.css'
import { defineComponent as d, computed as a, openBlock as r, createElementBlock as s, normalizeClass as h, createElementVNode as i, normalizeStyle as l, toDisplayString as v, Fragment as f, renderList as b, createCommentVNode as g } from "vue";
import "x-utils";
import "@vueuse/core";
import "lodash-es";
import { useI18n as y } from "./hooks/useLocale.js";
import "./hooks/useGlobalDark.js";
import "./layout/model/Model.js";
import "./layout/DockLocation.js";
import "./layout/Orientation.js";
import "./layout/model/TabNode.js";
import "./layout/model/TabSetNode.js";
import "./layout/model/BorderNode.js";
const z = { class: "rate-line" }, D = /* @__PURE__ */ d({
  name: "e-health-bar",
  __name: "health-bar",
  props: {
    options: { default: () => {
      const { t: o } = y();
      return [
        {
          text: o("common.CRITICAL"),
          color: "var(--bg-status-danger-bold)"
        },
        {
          text: o("common.FAIR"),
          color: "var(--bg-status-pending-bold)"
        },
        {
          text: o("common.GOOD"),
          color: "var(--bg-status-success-bold)"
        }
      ];
    } },
    value: {},
    size: {},
    cursorVisible: { type: Boolean, default: !0 },
    width: { default: 145 },
    cursorSize: { default: 6 }
  },
  setup(o) {
    const t = o, u = a(() => [
      "e-health-bar",
      t.size ? `e-health-bar--${t.size}` : void 0
    ]), n = a(() => Math.min(Math.floor(t.value), t.options.length - 1)), c = a(() => {
      const e = t.value / t.options.length * t.width;
      return e < 1 ? 1 : Math.min(e, t.width - t.cursorSize - 1);
    });
    return (e, C) => (r(), s("div", {
      class: h(u.value)
    }, [
      i("div", {
        class: "health-status",
        style: l({ color: e.options[n.value].color })
      }, v(e.options[n.value].text), 5),
      i("div", {
        class: "health-bar",
        style: l(`width: ${e.width}px;`)
      }, [
        i("div", z, [
          (r(!0), s(f, null, b(e.options, (m, p) => (r(), s("div", {
            key: p,
            style: l({ flex: 1, backgroundColor: m.color })
          }, null, 4))), 128))
        ]),
        e.cursorVisible ? (r(), s("div", {
          key: 0,
          class: "rate-cursor",
          style: l(`left: ${c.value}px;`)
        }, null, 4)) : g("", !0)
      ], 4)
    ], 2));
  }
});
export {
  D as default
};
//# sourceMappingURL=health-bar.js.map
